import React from "react";
import { useField } from "formik";
const tick = require("../../assets/Icon_Asset.png");

export function CheckboxInput<T>(props: {
  name: string;
  label?: string;
  className?: string;
}) {
  const fieldProps = { ...props, type: "checkbox" };
  const [field] = useField(fieldProps);
  const { className, label, ...rest } = fieldProps;

  const CheckboxCss = `
    input[type="checkbox"]:checked + .CustomInput:after {
      background-image: ${tick};
    }
  `;

  return (
    <div className="CheckboxContainer">
      <input
        {...(field as any)}
        {...rest}
        className={className ?? "CheckboxInput"}
        id={field.name}
      />
      <label className="CustomInput" htmlFor={field.name}>
        {label ?? ""}
      </label>
    </div>
  );
}
